import { Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/public/LandingPage';
import { PricingPage } from './pages/public/PricingPage';
import { ComparePage } from './pages/public/ComparePage';
import { NotFoundPage } from './pages/public/NotFoundPage';
import { LoginPage } from './pages/auth/LoginPage';
import { SignupPage } from './pages/auth/SignupPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { AppHome } from './pages/app/AppHome';
import { ProfilePage } from './pages/app/ProfilePage';
import { OnboardingPage } from './pages/onboarding/OnboardingPage';
import { WorkspacePage } from './pages/app/WorkspacePage';
import { AskPage } from './pages/app/AskPage';
import { DocsPage } from './pages/app/DocsPage';
import { DocViewerPage } from './pages/app/DocViewerPage';
import { UploadPage } from './pages/app/UploadPage';
import { ComposePage } from './pages/app/ComposePage';
import { BriefPage } from './pages/app/BriefPage';
import { AiResultsPage } from './pages/app/AiResultsPage';
import { SearchPage } from './pages/app/SearchPage';
import { CompareAgentPage } from './pages/app/CompareAgentPage';
import { AuditPage } from './pages/app/AuditPage';
import { ResearchPage } from './pages/app/ResearchPage';
import { SignalsPage } from './pages/app/SignalsPage';
import { WorkflowsPage } from './pages/app/WorkflowsPage';
import { ApprovalsPage } from './pages/app/ApprovalsPage';
import { SettingsPage } from './pages/app/SettingsPage';
import { AuditLogPage } from './pages/app/AuditLogPage';
import { ConnectorsPage } from './pages/app/ConnectorsPage';
import { SsoAdminPage } from './pages/app/SsoAdminPage';
import { ScimAdminPage } from './pages/app/ScimAdminPage';
import { ReportsPage } from './pages/app/ReportsPage';
import { PeoplePage } from './pages/app/PeoplePage';
import { DemoPage } from './pages/public/DemoPage';
import { PrivacyPage } from './pages/public/PrivacyPage';
import { TermsPage } from './pages/public/TermsPage';
import { DpaPage } from './pages/public/DpaPage';
import { SecurityPage } from './pages/public/SecurityPage';
import { SupportPage } from './pages/public/SupportPage';
import { StatusPage } from './pages/public/StatusPage';
import { ChangelogPage } from './pages/public/ChangelogPage';
import { OssPage } from './pages/public/OssPage';
import { SharedSnapshotPage } from './pages/public/SharedSnapshotPage';
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage';
import { AdminUsersPage } from './pages/admin/AdminUsersPage';
import { AdminCompaniesPage } from './pages/admin/AdminCompaniesPage';
import { AdminAuditPage } from './pages/admin/AdminAuditPage';
import { AdminEmailsPage } from './pages/admin/AdminEmailsPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/compare" element={<ComparePage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/legal/privacy" element={<PrivacyPage />} />
      <Route path="/legal/terms" element={<TermsPage />} />
      <Route path="/legal/dpa" element={<DpaPage />} />
      {/* Short aliases — Microsoft Marketplace cert and most external
          directories hit these without the /legal/ prefix. */}
      <Route path="/privacy" element={<Navigate to="/legal/privacy" replace />} />
      <Route path="/terms" element={<Navigate to="/legal/terms" replace />} />
      <Route path="/dpa" element={<Navigate to="/legal/dpa" replace />} />
      <Route path="/support" element={<SupportPage />} />
      <Route path="/security" element={<SecurityPage />} />
      <Route path="/status" element={<StatusPage />} />
      <Route path="/changelog" element={<ChangelogPage />} />
      <Route path="/oss" element={<OssPage />} />
      <Route path="/share/:id" element={<SharedSnapshotPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/app" element={<AppHome />} />
      <Route path="/app/profile" element={<ProfilePage />} />
      <Route path="/app/workspace/:wsId" element={<WorkspacePage />} />
      <Route path="/app/workspace/:wsId/ask" element={<AskPage />} />
      <Route path="/app/workspace/:wsId/ask/:conversationId" element={<AskPage />} />
      <Route path="/app/workspace/:wsId/search" element={<SearchPage />} />
      <Route path="/app/workspace/:wsId/docs" element={<DocsPage />} />
      <Route path="/app/workspace/:wsId/docs/:docId" element={<DocViewerPage />} />
      <Route path="/app/workspace/:wsId/upload" element={<UploadPage />} />
      <Route path="/app/workspace/:wsId/compose" element={<ComposePage />} />
      <Route path="/app/workspace/:wsId/brief" element={<BriefPage />} />
      <Route path="/app/workspace/:wsId/compare-docs" element={<CompareAgentPage />} />
      <Route path="/app/workspace/:wsId/audit" element={<AuditPage />} />
      <Route path="/app/workspace/:wsId/research" element={<ResearchPage />} />
      <Route path="/app/workspace/:wsId/results" element={<AiResultsPage />} />
      <Route path="/app/workspace/:wsId/signals" element={<SignalsPage />} />
      <Route path="/app/workspace/:wsId/workflows" element={<WorkflowsPage />} />
      <Route path="/app/workspace/:wsId/approvals" element={<ApprovalsPage />} />
      <Route path="/app/workspace/:wsId/settings" element={<SettingsPage />} />
      <Route path="/app/workspace/:wsId/audit-log" element={<AuditLogPage />} />
      <Route path="/app/workspace/:wsId/connectors" element={<ConnectorsPage />} />
      <Route path="/app/workspace/:wsId/sso" element={<SsoAdminPage />} />
      <Route path="/app/workspace/:wsId/scim" element={<ScimAdminPage />} />
      <Route path="/app/workspace/:wsId/people" element={<PeoplePage />} />
      <Route path="/app/workspace/:wsId/reports" element={<ReportsPage />} />
      <Route path="/admin" element={<AdminOverviewPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/admin/companies" element={<AdminCompaniesPage />} />
      <Route path="/admin/audit" element={<AdminAuditPage />} />
      <Route path="/admin/emails" element={<AdminEmailsPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/register" element={<Navigate to="/signup" replace />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
